'use client'
import { Typography } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import classNames from 'classnames'

export default function FooterCopyright({ content, className, 'data-testid': dataTestId }) {
  const currentYear = new Date().getFullYear()

  if (typeof content === 'string') {
    return (
      <Typography
        content={`© ${currentYear} ${content}`}
        variant="bodyXs"
        fontWeight="regular"
        className={className}
        data-testid={dataTestId}
      />
    )
  }

  return (
    <div
      className={classNames(
        className,
        '[&_p:last-child]:mb-0 [&_p:first-of-type]:inline [&_p:not(:first-of-type)]:block'
      )}
      data-testid={dataTestId}
    >
      <Typography
        component="span"
        variant="bodyXs"
        fontWeight="regular"
        className="inline"
        content={`© ${currentYear} `}
      />
      <Typography
        content={content}
        variant="bodyXs"
        fontWeight="regular"
        variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyXs' }}
        styleOverride={{ [BLOCKS.PARAGRAPH]: { marginBottom: '4px' } }}
      />
    </div>
  )
}
